import React from 'react'

import SelectCustom from './index'

const DashboardSelect = ({
  isSearchable = false,
  minWidth,
  onChange,
  options,
  styles,
  value,
  ...props
}) => (
  <SelectCustom
    {...props}
    isSearchable={isSearchable}
    options={options}
    value={options.find((option) => option.value === value) || null}
    onChange={(option) => onChange(option?.value)}
    styles={{
      container: (base) => ({
        ...base,
        minWidth,
      }),
      ...styles,
    }}
  />
)

DashboardSelect.defaultProps = {
  minWidth: 190,
  styles: {},
}

export const PageSizeSelect = ({
  isSearchable = false,
  onChange,
  options,
  value,
}) => (
  <DashboardSelect
    className="mr-3 dashboard-page-size-select"
    isSearchable={isSearchable}
    menuPlacement="top"
    minWidth={String(value).length > 1 ? 100 : 90}
    options={options.map((option) => ({
      label: `${option} rows`,
      value: option,
    }))}
    value={value}
    onChange={onChange}
    formatOptionLabel={(option, { context }) =>
      context === 'value' ? (
        <span className="d-flex align-items-center">
          <i className="feather icon-list mr-2" />
          {option.label}
        </span>
      ) : (
        <span className="d-flex align-items-center justify-content-between">
          {option.label}
          {option.value === value && (
            <i className="feather icon-check ml-3" />
          )}
        </span>
      )
    }
    styles={{
      control: (base) => ({
        ...base,
        backgroundColor: '#f8f9fa',
        border: '1px solid #f8f9fa',
        borderRadius: 7,
        boxShadow: 'none',
        fontSize: 13,
        height: 31,
        minHeight: 31,
        '&:hover': {
          borderColor: '#f8f9fa',
        },
      }),
      dropdownIndicator: (base) => ({
        ...base,
        color: '#7b8ba1',
        padding: 4,
        svg: {
          height: 14,
          width: 14,
        },
      }),
      menu: (base) => ({
        ...base,
        border: '1px solid #dfe7ef',
        borderRadius: 8,
        boxShadow: '0 8px 18px rgba(33, 77, 122, 0.14)',
        minWidth: 128,
        overflow: 'hidden',
      }),
      menuList: (base) => ({
        ...base,
        padding: '4px 10px',
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? '#4094f7' : '#ffffff',
        borderRadius: 5,
        color: state.isSelected ? '#ffffff' : '#25384b',
        cursor: 'pointer',
        fontSize: 13,
        padding: '7px 10px',
        '&:active': {
          backgroundColor: state.isSelected ? '#4094f7' : '#edf5ff',
        },
        '&:hover': {
          backgroundColor: state.isSelected ? '#4094f7' : '#f5f7fa',
        },
      }),
      singleValue: (base) => ({
        ...base,
        color: '#4b647c',
        margin: 0,
      }),
      valueContainer: (base) => ({
        ...base,
        padding: '0 9px',
      }),
    }}
  />
)

export default DashboardSelect
